import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { IoMdClose } from "react-icons/io";
function ReusableFilterDateAndName() {
  const [clicked, setClicked] = useState(false);
  const [addInfo, setAddInfo] = useState(false);
  const AddDetails = () => {
    setAddInfo(true);
  };
  const FormData = [
    {
      type: "text",
      apikey: "username",
      placeholder: "Username",
    },
    {
      type: "date",
      apikey: "date",
    },
    {
      options: [
        {
          as: "select",
          apikey: "half_day",
          option: "choose any information",
        },
        {
          as: "select",
          apikey: "half_day",
          option: "half day",
        },
        {
          as: "select",
          apikey: "full_day",
          option: "full day",
        },
        {
          as: "select",
          apikey: "absent",
          option: "absent",
        },
        {
          as: "select",
          apikey: "overtime",
          option: "overtime",
        },
      ],
    },
  ];
  const monthFormData = [
    { option: "january" },
    { option: "feburary" },
    { option: "march" },
    { option: "april" },
    { option: "may" },
    { option: "june" },
    { option: "july" },
    { option: "august" },
    { option: "september" },
    { option: "october" },
    { option: "november" },
    { option: "december" },
  ];
  const SignupSchema = Yup.object().shape({
    username: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    date: Yup.string().required("Required"),
  });
  let YearGeneration = new Date().getFullYear();
  let dates = [YearGeneration];
  for (let i = 1; i <= 10; i++) {
    let date = YearGeneration + i;
    dates.push(date);
    let datetwo = YearGeneration - i;
    dates.push(datetwo);
  }
  console.log(dates.sort());
  let mod;
  if (addInfo) {
    mod = (
      <div className="bg-black  bg-opacity-70 w-full flex justify-center items-center h-full z-50 fixed top-0 bottom-0 right-0  left-0">
        <div className="bg-white   z-50  rounded-md  px-6 py-5 w-5/12    ">
          <div className="flex gap-10  ">
            <div className=" w-full">
              <Formik
                initialValues={{
                  username: "",
                  date: "",
                  halfday: "",
                  fullday: "",
                  absent: "",
                  overtime: "",
                }}
                validationSchema={SignupSchema}
                onSubmit={(values) => {
                  // same shape as initial values
                  console.log(values);
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    {FormData.map((val, i) => {
                      if (val.options) {
                        return (
                          <div key={i}>
                            {/* <div> */}
                            <select className=" my-4 w-full h-10 bg-gray-200 capitalize text-gray-600 rounded-sm outline-none  px-2 py-1">
                              {val.options.map((opt, i) => {
                                return <option>{opt.option}</option>;
                              })}
                            </select>
                            {/* </div> */}
                            <div className="text-red-400 text-xs font-medium">
                              {errors[val.apikey] && touched[val.apikey] ? (
                                <div>{errors[val.apikey]}</div>
                              ) : null}
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={i}>
                            <div>
                              <Field
                                className=" bg-gray-200  w-full h-9 text-gray-600 rounded-sm outline-none  my-4 px-2 py-1"
                                type={val.type}
                                placeholder={val.placeholder}
                                name={val.apikey}
                              />
                            </div>
                            <div className="text-red-400 text-xs font-medium">
                              {errors[val.apikey] && touched[val.apikey] ? (
                                <div>{errors[val.apikey]}</div>
                              ) : null}
                            </div>
                          </div>
                        );
                      }
                    })}

                    <div className="w-full">
                      <button
                        type="submit"
                        className="bg-green-500 px-5 py-2 w-fit text-white font-medium rounded-sm shadow-lg shadow-gray-400"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div
              className="flex justify-end w-fit h-fit border-2 p-1 rounded-full text-2xl  cursor-pointer hover:scale-105 "
              onClick={() => setAddInfo(false)}
            >
              <IoMdClose />
            </div>
          </div>
        </div>{" "}
      </div>
    );
  }
  return (
    <div className="flex justify-end">
      {mod}
      <div className="flex justify-end  w-7/12 p-5">
        <div className="w-4/12   col-span-2">
          <div className="flex gap-3 items-center  mt-1  ">
            {" "}
            <div className="flex  gap-1 items-center text-sm   tablet:text-base capitalize">
              <select className="border rounded-sm text-gray-600 border-black py-1 px-2">
                {dates.map((val, i) => {
                  return <option key={i}>{val}</option>;
                })}
              </select>
            </div>
            <div className="flex  items-center gap-1 text-sm tablet:text-base capitalize">
              <select className="border capitalize  text-gray-600 rounded-sm border-black py-1 px-2">
                {monthFormData.map((val, i) => {
                  return <option>{val.option}</option>;
                })}
              </select>
            </div>{" "}
          </div>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={() => AddDetails()}
            className="px-5 py-2 text-white  font-semibold cursor-pointer capitalize bg-green-500 rounded-sm  drop-shadow-md"
          >
            Add details
          </button>
          <button className="px-5 py-2 text-white  font-semibold cursor-pointer capitalize bg-orange-500 rounded-sm  drop-shadow-md">
            Export
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReusableFilterDateAndName;
